


















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Course, Child, Outline, MyLearn } from '@/model/course/course'
import { State, Action, namespace } from 'vuex-class'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import { getMyLearn, saveMyLearn } from '@/api/course/course'
import MyLearnEmpty from './empty.vue'
import { Account } from 'ykd-base/account'
import { CourseProduct } from '@/model/product/courseProduct'
import { CollegeProduct } from '@/model/product/collegeProduct'
import { log } from 'util'
import str2base64 from '@/apps/ice/utils/path'

const ModuleUser = namespace('app-ice/user')
const ModuleAccount = namespace('app-ice/account')
const ModuleProduct = namespace('app-ice/product')

@Component({
  components: {
    MyLearnEmpty
  }
})
export default class MyAllCourse extends Vue {
  @ModuleAccount.State(state => state.account)
  private account!: Account
  @ModuleAccount.Action('fetchAccount')
  fetchAccount!: Function
  @ModuleUser.State(state => state.myLearn)
  private myLearn!: MyLearn
  @ModuleUser.Action('getMyLearn')
  getMyLearn!: Function
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function
  @ModuleProduct.State(state => state.productList)
  private productList?: CollegeProduct[]

  @ModuleUser.Getter('currentCourse')
  currentCourse?: Child

  private loading: boolean = true
  private checkChild: any = ''

  async mounted() {
    await this.fetchAccount()
    await this.getTrialCourse()
    this.loading = false

    //  to open
    setInterval(async () => {
      await this.getMyLearn()
      this.handleMyLearn()
    }, 180000)
  }

  private async getTrialCourse() {
    const outlineId = this.$route.query.id as string
    if (outlineId) {
      await saveMyLearn([outlineId])
      this.$router.push({
        query: {}
      })
    }
  }

  private toLearn(item: Child) {
    if (item.unlock) {
      window.open(
        `https://ham.youkeda.com/course/${item.myCourse.courseId}/${str2base64(
          item.myCourse.learnUrl || ''
        )}`
      )
    }
  }

  get percent() {
    if (
      this.currentCourse &&
      this.currentCourse.myCourse &&
      this.currentCourse.myCourse.process
    ) {
      const process = this.currentCourse.myCourse.process
      return process > 100 ? 100 : process < 0 ? 0 : process
    }
    return 0
  }

  private isCurrentSection(id: string, lastSectionId: string) {
    const arr = id.match(/(\d+)/g) || []
    const arr2 = lastSectionId.match(/(\d+)/g) || []
    // arr2!.pop(); learnUrl
    return arr!.join('-') === arr2!.join('-')
  }

  get curOutline() {
    let arr: any = []
    if (this.currentCourse && this.currentCourse.myCourse.lastSectionId) {
      arr = this.currentCourse.myCourse.lastSectionId.match(/(\d+)/g) || []
    }
    return +(arr && arr.length > 1 && arr[1]) || 1
  }

  get curOutlineChinese() {
    return num2Chinese(this.curOutline)
  }

  get curSections() {
    if (this.currentCourse) {
      return this.currentCourse.outlines[this.curOutline - 1].sections || []
    } else {
      return []
    }
  }
}
